import { topbarTokens } from '../Topbar/tokens';

export const creditsTokens = {
    ...topbarTokens,
    color: {
        ...topbarTokens.color,
        // Verde para las entradas de crédito, el rojo de la marca para los consumos.
        credit: '#0F7B4F',
        debit: topbarTokens.color.danger,
        chipBg: '#F3F4F6',
    },
};
